export default {
    data() {
        return {
            list: [],
            // 产品id
            product_id: null,
            //项目id
            project_id: null,
            // 根据获取的数据决定url
            url: '',
            // 规则数组
            // 0：系统自动评分  1：辅导员评分  2：项目心得500字
            rules: [
                {
                    value: 0,
                    rule: '系统自动评分',
                },
                {
                    value: 1,
                    rule: '辅导员评分',
                },
                {
                    value: 2,
                    rule: '项目心得100字',
                },
            ]
        }
    },
    methods: {
        submit() {
            const flag1 = this.handlePhaseScore()
            const flag2 = this.handleCourseScore()
            const flag3 = this.handleChapterScore()
            if (flag1 && flag2 && flag3) {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                const data = {
                    token: this.$store.state.authority_management,
                    resources: JSON.stringify(this.list),
                    product_id: this.product_id,
                    shop_id: this.$store.state.store.id,
                }
                this.$post(this.url, data).then(res => {
                    this.$router.push('/itemproductlist')
                })
            }
        },
        //返回按钮
        back() {
            this.$router.push('/itemproductlist');
        },

        // 处理阶段分数百分比
        handlePhaseScore() {
            let phaseScore = 0
            const list = this.list
            for (let i = 0; i < list.length; i++) {
                phaseScore += Number(list[i].percentage)
            }
            if (phaseScore !== 100) {
                this.$message.error('所有阶段百分比总和应为100%');
                phaseScore = 0
                return false
            }
            phaseScore = 0
            this.list = list
            return true
        },

        // 处理课程分数百分比
        handleCourseScore() {
            let courseScore = 0
            const list = this.list
            for (let i = 0; i < list.length; i++) {
                for (let j = 0; j < list[i].task_activities.length; j++) {
                    courseScore += Number(list[i].task_activities[j]['percentage'])
                }
                if (courseScore !== 100) {
                    this.$message.error('每个课程百分比总和应为100%');
                    courseScore = 0
                    return false
                }
                courseScore = 0
            }
            this.list = list
            return true
        },

        // 处理章节分数百分比
        handleChapterScore() {
            let chapterScore = 0
            const list = this.list
            for (let i = 0; i < list.length; i++) {
                for (let j = 0; j < list[i].task_activities.length; j++) {
                    for (let k = 0; k < list[i].task_activities[j].resources.length; k++) {
                        chapterScore += Number(list[i].task_activities[j].resources[k]['percentage'])
                    }
                    if (chapterScore !== 100) {
                        this.$message.error('每个章节的百分比总和应为100%');
                        chapterScore = 0
                        return false
                    }
                    chapterScore = 0
                }
            }
            this.list = list
            return true
        },

        // 选择器选中的值发生变化
        handleSelectChange(event, obj) {
            const rule = Number(event.target.value)
            obj.rule = rule
        },

        // 什么也不做
        doSomething() {
        },

        // 初始化数组对象
        initList() {
            const that = this
            const data = {
                token: this.$store.state.authority_management,
                offset: 0,
                length: 100,
                project_id: this.project_id
            }
            that.$post('project_tasks/search_group_by_task', data).then(res => {
                // console.log('list1', res.data.result.data)
                that.list = res.data.result.data.map(item => {
                    // item为项目里的每个阶段
                    // 循环item是为了将课程下的字符串表示的章、节转换成对象数组
                    for (let i = 0; i < item.task_activities.length; i++) {
                        item.task_activities[i].resources = JSON.parse(item.task_activities[i].resources)
                    }
                    return item
                })
                // console.log('list2', that.list)
                let list = that.list
                for (let i = 0; i < list.length; i++) {
                    list[i]['percentage'] = null
                    for (let j = 0; j < list[i].task_activities.length; j++) {
                        list[i].task_activities[j]['percentage'] = null
                        for (let k = 0; k < list[i].task_activities[j].resources.length; k++) {
                            list[i].task_activities[j].resources[k]['percentage'] = null
                            let length = list[i].task_activities[j].resources[k].items.length
                            for (let l = 0; l < length; l++) {
                                // 添加小节评分规则
                                list[i].task_activities[j].resources[k].items[l]['rule'] = 0
                                let percentage = (100 / length).toFixed()
                                if (length === (l + 1)) {
                                    let difference = Number(100 - percentage * length)
                                    list[i].task_activities[j].resources[k].items[l]['percentage'] = percentage * 1 + difference * 1
                                    break
                                }
                                list[i].task_activities[j].resources[k].items[l]['percentage'] = Number(percentage)
                            }
                        }
                    }
                }
                that.list = list
                // this.fillPercentage(that.list);
            })
        },

        /**
         * 填充分数百分比
         */
        fillPercentage(list) {
            console.log(list);
            // 数组长度、平均百分比、最后一个百分比，余数
            let {len, averagePercentage, lastPercentage, remainder} = this.calc(list);
            list.forEach((item1, index1) => {
                // 第一层的分数占比。数组长度为6的按10、10、20、20、20、20
                if (len === 6 && (index1 === 0 || index1 === 1)) {
                    item1.percentage = 10;
                } else if (len === 6 && (index1 >= 2 && index1 <= 5)) {
                    item1.percentage = 20;
                } else {
                    // 平均百分比
                    item1.percentage = averagePercentage;
                    if (remainder !== 0 && index1 === len - 1) {
                        item1.percentage = lastPercentage;
                    }
                }

                // 第二层的分数占比，平均百分比
                let {len: len2, averagePercentage: averagePercentage2, lastPercentage: lastPercentage2, remainder: remainder2} = this.calc(item1.task_activities);
                item1.task_activities.forEach((item2, index2) => {
                    item2.percentage = averagePercentage2;
                    if (remainder2 !== 0 && index2 === len2 - 1) {
                        item2.percentage = lastPercentage2;
                    }

                    // 第三层的分数占比，平均百分比
                    let {len: len3, averagePercentage: averagePercentage3, lastPercentage: lastPercentage3, remainder: remainder3} = this.calc(item2.resources);
                    item2.resources.forEach((item3, index3) => {
                        item3.percentage = averagePercentage3;
                        if (remainder3 !== 0 && index3 === len3 - 1) {
                            item3.percentage = lastPercentage3;
                        }

                        // 第四层的课程作业规则改成辅导员评分
                        item3.items.forEach(item4 => {
                            if (Number.parseInt(item4.type) === 7) {
                                item4.rule = 1;
                            }
                        })
                    });
                });
            });
        },

        /**
         * 根据给定的数组，计算返回该数组的长度
         * @param list
         */
        calc(list) {
            let len, averagePercentage, lastPercentage, remainder;
            len = list.length;
            averagePercentage = Math.floor(100 / len);
            remainder = 100 % len;
            // 不能整除，最后一个加上余数
            if (remainder !== 0) {
                lastPercentage = averagePercentage + remainder;
            }
            return {
                len,
                averagePercentage,
                lastPercentage,
                remainder
            };
        }

    },
    mounted() {
        this.product_id = this.$route.query.product_id;
        this.project_id = this.$route.query.project_id;
        const data = {
            token: this.$store.state.authority_management,
            product_id: this.product_id,
            shop_id: this.$store.state.store.id
        }
        const that = this
        // $isAbnormal
        that.$post('proportion/get', data).then(res => {
            if (that.$isAbnormal(res.data.result)) {
                // 调用方法获取数据并添加百分比属性和评分规则属性
                this.initList()
                this.url = 'proportion/create'
            } else {
                this.url = 'proportion/edit'
                this.list = JSON.parse(res.data.result.resources)
                // console.log('list', this.list)
            }
        })

    }
}
